import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { LoungePassesExperienceTile } from './LoungePassesLoungeTile'

const TilesGrid = styled.div`
  display: grid;
  gap: ${rem(16)};
  grid-template-columns: 1fr;

  ${mediaQueryUp.tablet} {
    gap: ${rem(20)};
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`

interface Props {
  regionName: string
  experiences: Array<App.ExperienceOffer>
  onViewAll: () => void
}

function LoungePassesRegionGroup({ regionName, experiences, onViewAll }: Props) {
  return <Group direction="vertical" gap={20}>
    <Heading variant="heading3">{regionName}</Heading>
    <TilesGrid>
      {experiences.map(experience => (
        <LoungePassesExperienceTile key={experience.id} experience={experience} />
      ))}
    </TilesGrid>
    <div>
      <TextButton kind="secondary" onClick={onViewAll}>
        <FormattedMessage
          id="MlvVBMQzfzOZR_9uzgFB"
          defaultMessage="View all"
          description="Button to view all available lounges within a region group"
        />
      </TextButton>
    </div>
  </Group>
}

export default LoungePassesRegionGroup
